import React from 'react';
import {Box, Button} from '@mui/material';
import Typography from '@mui/material/Typography';
import {formatDate} from '../../../../utility/dateUtil';
import PropTypes from 'prop-types';

const ActionConfirmButton = (
    {
        confirmedAt,
        confirmedBy,
        onConfirm,
        onSave,
        enableSaveButton,
        enableConfirmButton = true,
        readonly,
        confirmButtonText = 'Confirm',
        additionalActions = null
    }) => {
    return (
        <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            justifyContent={{ xs: 'stretch', sm: 'end' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            marginTop={2}
            gap={2}
            flexWrap="wrap"
        >
            {
                confirmedAt && confirmedBy
                    ? <Typography>Confirmed at {formatDate(confirmedAt)} by {confirmedBy}</Typography>
                    : ''
            }
            {!enableSaveButton && !confirmedAt
                ? <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#186BBE',
                        boxShadow: 'none',
                        width: { xs: '100%', sm: 'auto' },
                        minWidth: { sm: 100 },
                        '&:hover': {
                            backgroundColor: '#155FA7',
                            boxShadow: 'none'
                        }
                    }}
                    disabled={!enableConfirmButton}
                    onClick={onConfirm}>{confirmButtonText}
                </Button>
                : !readonly
                    ? <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#186BBE',
                            boxShadow: 'none',
                            width: { xs: '100%', sm: 'auto' },
                            minWidth: { sm: 100 },
                            '&:hover': {
                                backgroundColor: '#155FA7',
                                boxShadow: 'none'
                            }
                        }}
                        onClick={onSave}
                        disabled={!enableSaveButton}>Save
                    </Button>
                    : null
            }
            {additionalActions}
        </Box>
    );
};

ActionConfirmButton.propTypes = {
    confirmedAt: PropTypes.string,
    confirmedBy: PropTypes.string,
    onConfirm: PropTypes.func,
    onSave: PropTypes.func,
    enableSaveButton: PropTypes.bool,
    enableConfirmButton: PropTypes.bool,
    readonly: PropTypes.bool,
    confirmButtonText: PropTypes.string,
    additionalActions: PropTypes.node
};

export default ActionConfirmButton;